import { render, staticRenderFns } from "./boards.vue?vue&type=template&id=428985fd&scoped=true&"
import script from "./boards.vue?vue&type=script&lang=js&"
export * from "./boards.vue?vue&type=script&lang=js&"
import style0 from "./boards.vue?vue&type=style&index=0&id=428985fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428985fd",
  null
  
)

export default component.exports